import { Box, Flex, Image, ListItem, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, UnorderedList } from '@chakra-ui/react'
import { ContentLabel } from './Insurer'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { Link } from 'react-router-dom'
import { AppSettings } from '@/appSettings'

const baseUrl = AppSettings.baseUrl + '/docs/uniqa/'

const UniqaContent = () => {
  return (
    <Stack m={4} gap={10}>
      <ZakladniInformace />

      <PovinneRuceni />

      <HavarijniPojisteni />

      <DoplnkovaPripojisteni />

      <AKCE />

      <PrimaLikvidace />

      <Documents />
    </Stack>
  )
}

export default UniqaContent

const ZakladniInformace = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Základní informace</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <UnorderedList>
          <ListItem>poskytuje placení pojistného bez přirážky za področní splátky při placení inkasem z účtu nebo prostřednictvím SIPO</ListItem>
          <ListItem>poskytuje slevy z pojištění KASKO za zabezpečení vozidla – např. sleva 10 % za zabezpečení vozidla „pískováním skel“ SBZ OCIS</ListItem>
          <ListItem>umožňuje výběr správné výše bonusu POV z databáze ČKP a jeho převod i na KASKO pojištění</ListItem>
          <ListItem>nabízí výhodné pojištění pro osoby starší 55 let a lékaře zvýhodňuje mladé řidiče s bezeškodním průběhem v posledních třech letech</ListItem>
          <ListItem>poskytuje 10% slevu z pojištění KASKO za kombinaci produktů POV + KASKO</ListItem>
          <ListItem>
            poskytuje jako bonus balíčky připojištění
            <UnorderedList listStyleType='circle'>
              <ListItem>pojištění zavazadel a sedadel ve vozidle za zvýhodněnou cenu 700 Kč</ListItem>
            </UnorderedList>
          </ListItem>
          <ListItem>Kasko Max - klient má nárok na pojistné plnění ve výši pořizovací ceny svého vozidla v případě totální škody po dobu 1 roku (KASKO MAX 12) nebo 3 let (KASKO MAX 36) po odečtení spoluúčasti a zbytků. Produkt je určen pro nová osobní vozidla. Nově tento produkt umožňuje připojistit všechna doplňková připojištění se slevou 50%. U smluv sjednaných podle nových DPP od 1.6.2015 lze po ukončení Gapové složky (po uplynutí 12 resp. 36 měsíců) snižovat pojistnou částku vozidla.</ListItem>
        </UnorderedList>
      </Stack>
    </Stack>
  )
}

const PovinneRuceni = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Povinné ručení</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <TableContainer>
          <Table colorScheme='blue'>
            <Thead>
              <Tr bg={'blue'}>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Název</Th>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Plnění zdraví/majetek</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>Zákonné limity</Td>
                <Td>35/35 mil. Kč</Td>
              </Tr>
              <Tr>
                <Td>Zvýšené limity</Td>
                <Td>50/60 mil. Kč</Td>
              </Tr>
              <Tr>
                <Td>Zvýšené limity</Td>
                <Td>100/100 mil. Kč</Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>

      </Stack>
    </Stack >
  )
}

const HavarijniPojisteni = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Havarijní pojištění</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <TableContainer>
          <Table colorScheme='blue'>
            <Thead>
              <Tr bg={'blue'}>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Název</Th>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Krytí</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>Kompletní pojištění</Td>
                <Td>
                  <UnorderedList>
                    <ListItem>Havárie</ListItem>
                    <ListItem>Odcizení</ListItem>
                    <ListItem>Živelné škody</ListItem>
                    <ListItem>Vandalismus</ListItem>
                    <ListItem>Pád věci na vůz</ListItem>
                  </UnorderedList>
                </Td>
              </Tr>
              <Tr>
                <Td>Pojištění havárie</Td>
                <Td>
                  <UnorderedList>
                    <ListItem>Havárie</ListItem>
                    <ListItem>Živelné škody</ListItem>
                    <ListItem>Pád věci na vůz</ListItem>
                  </UnorderedList>
                </Td>
              </Tr>
              <Tr>
                <Td>Pojištění odcizení</Td>
                <Td>
                  <UnorderedList>
                    <ListItem>Odcizení</ListItem>
                    <ListItem>Živelné škody</ListItem>
                  </UnorderedList>
                </Td>
              </Tr>
              <Tr>
                <Td>KaskoMax</Td>
                <Td>
                  <UnorderedList>
                    <ListItem>Havárie</ListItem>
                    <ListItem>Odcizení</ListItem>
                    <ListItem>Živelné škody</ListItem>
                    <ListItem>Vandalismus</ListItem>
                    <ListItem>Pád věci na vůz</ListItem>
                    <ListItem>Pojištění pořizovací ceny vozidla</ListItem>
                  </UnorderedList>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>

        <ContentLabel label='Spoluúčasti:' />
        <UnorderedList>
          <ListItem>5% z pojistného plnění minimálně 5 000 Kč</ListItem>
          <ListItem>10% z pojistného plnění minimálně 10 000 Kč</ListItem>
        </UnorderedList>
        <Text marginTop={6}>pozn.: sjednaná spoluúčast platí jen v autorizované síti, při opravě mimo se spoluúčast zvyšuje na dvojnásobek</Text>
      </Stack>
    </Stack >
  )
}

const DoplnkovaPripojisteni = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Doplňková připojištění</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <ContentLabel label='Asistence:' />
        <Text>Základní asistence v ceně pojištění <Link to={'/docs/uniqa/letak_asistence_15.pdf'} target='_blank' style={{ color: 'blue' }}>Detailní rozsah asistence.</Link></Text>

        <ContentLabel label='Pojištění čelního skla LIMIT:' />
        <Text>Pojistné plnění za jednu či více škod v jenom pojistném roce nesmí přesáhnout pojistnou částku. Pro první rok je pojistné vždy vyšší. Pokud z produktu Skla LIMIT v prvním roce pojištění není škoda, tak se pojistné na základě žádosti klienta na další období (2. rok a další roky) snižuje na polovinu. Pokud je v prvním roce škoda, tak pojistné zůstává beze změny.</Text>
        <TableContainer>
          <Table colorScheme='blue'>
            <Thead>
              <Tr bg={'blue'}>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Název</Th>
                <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Cena</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>pojistná částka 4.000 Kč, spoluúčast 500 Kč	</Td>
                <Td>600 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 6.000 Kč, spoluúčast 500 Kč	</Td>
                <Td>900 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 8.000 Kč, spoluúčast 500 Kč	</Td>
                <Td>1.200 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 10.000 Kč, spoluúčast 500 Kč</Td>
                <Td>1.500 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 15.000 Kč, spoluúčast 500 Kč</Td>
                <Td>2.250 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 20.000 Kč, spoluúčast 500 Kč</Td>
                <Td>3.000 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 30.000 Kč, spoluúčast 500 Kč</Td>
                <Td>4.500 Kč</Td>
              </Tr>
              <Tr>
                <Td>pojistná částka 40.000 Kč, spoluúčast 500 Kč</Td>
                <Td>6.000 Kč</Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>

        <ContentLabel label='Balíček:' />
        <Text>Zvýhodněná kombinace doplňkových pojištění</Text>
        <Table colorScheme='blue'>
          <Thead>
            <Tr bg={'blue'}>
              <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Název</Th>
              <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Popis</Th>
              <Th bg={'blue.600'} color={'white'} fontWeight={'bold'}>Cena</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Připojištění balíček Sedadla + Zavazadla</Td>
              <Td>
                <UnorderedList>
                  <ListItem>Sedadla - paušální systém 100.000 Kč smrt, 100.000 Kč trvalá invalidita, 100 Kč nemocniční odškodné</ListItem>
                  <ListItem>Zavazadla - pojistná částka 15.000 Kč. spoluúčast 5% z pojistného plnění,min. 500 Kč.</ListItem>
                </UnorderedList>
              </Td>
              <Td>700 Kč</Td>
            </Tr>
            <Tr>
              <Td>Připojištění balíček TRIO Sedadla + Zavazadla + Asistence</Td>
              <Td>
                <UnorderedList>
                  <ListItem>Sedadla - paušální systém 100.000 Kč smrt, 100.000 Kč trvalá invalidita, 100 Kč nemocniční odškodné.</ListItem>
                  <ListItem>Zavazadla - pojistná částka 15.000 Kč. spoluúčast 5% z pojistného plnění,min. 500 Kč.</ListItem>
                  <ListItem>Rozšířená asistence UNIQA (ČR i zahraničí)</ListItem>
                </UnorderedList>
              </Td>
              <Td>950 Kč</Td>
            </Tr>
          </Tbody>
        </Table>

        <ContentLabel label='Připojištění skel, ráfků a pneumatik' />
        <UnorderedList>
          <ListItem>S ohledem na výluky při škodách na samotných sklech, pneumatikách a ráfcích, se doporučuje tato pojistná nebezpečí připojistit doplňkovým připojištěním. Výhodou připojištění je, že případně pojistné události nemají vliv na Bonus a je u nich sjednána výrazně nižší spoluúčast.</ListItem>
        </UnorderedList>

      </Stack>
    </Stack >
  )
}

const AKCE = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>AKCE SafeLine RENT+</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <ContentLabel label='Specifika produktu SafeLine RENT+:' />
        <Text>Instalace telematické jednotky s nárazovým čidlem a tlačítkem B-call. Zaznamená-li nárazové čidlo přetížení a systém operátora telematické jednotky jej vyhodnotí jako havárii a neprodleně alarmuje operátora asistenční služby. Operátor asistenční služby volá postupně na všechna čísla v systému SafeLine (klient je sdělil při montáži vozidla) a současně vyhodnocuje situaci, zda je vozidlo dále v pohybu.</Text>
        <UnorderedList>
          <ListItem>Pokud se může spojit s hlavním telefonním číslem, domluví se s klientem co je třeba</ListItem>
          <ListItem>Vozidlo nepokračuje v další cestě, ale operátor se nemůže spojit s hlavním telefonním číslem, pokouší se opakovaně dovolat na telefonní kontakty</ListItem>
          <ListItem>
            Pokud volání:
            <UnorderedList listStyleType='circle'>
              <ListItem>Je úspěšné, pak se operátor dohodne s klientem co dál</ListItem>
              <ListItem>Není stále úspěšné, podle povahy události se kontaktuje linka 112 nebo odtahová služba</ListItem>
            </UnorderedList>
          </ListItem>
        </UnorderedList>

        <ContentLabel label='Sjednání pojištění se SafeLine Rent+:' />
        <UnorderedList>
          <ListItem>Lze sjednat k tomuto pojištění za cenu 3.900 Kč ročně.</ListItem>
        </UnorderedList>

      </Stack>
    </Stack >
  )
}

const PrimaLikvidace = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Přímá likvidace škod Profík</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <Text>Z přímé likvidace škod Profík se likvidují škody při nehodách, jejichž viníkem je někdo jiný. UNIQA v těchto případech zlikviduje škodu, vyplatí náhradu a poté si ji vyžádá od pojišťovny viníka zpět. Rozšíření o přímou likvidaci se týká všech klientů, kteří mají sjednánu komfortnější asistenční službu či značkové pojištění.</Text>

      </Stack>
    </Stack >
  )
}

const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'uniqa_vpp.pdf',
            name: 'Soubor VPP_19 - Pojištění vozidel',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'uniqa_asistence.pdf',
            name: 'Popis a rozsah asistence',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'vypoved_prodej.pdf',
            name: 'Výpověď pojištění z důvodu prodeje vozidla',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'das_ucz_15.pdf',
            name: 'Soubor pojistných podmínek D.A.S._15',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'uniqa_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          }
        ]} />
      </Stack>
    </Stack >
  )
}
